import { withRouter } from 'react-router-dom';

const TimeOffRequest = () => null;

export default withRouter(TimeOffRequest);
